import React, { useEffect, useCallback } from 'react';
import { FormattedDate, useIntl } from 'react-intl';
import CheckInput, { InputType } from '../../../../../atoms/CheckInput';
import { PaymentMethodTicket } from '../../../../../interfaces/merchants/resources/books';
import { BookingPurchaseProductList } from '../BookingPurchaseProductList';

import css from './InputPaymentMyTicket.module.scss';

interface Props {
  paymentMethod: PaymentMethodTicket;
  onSelect: (purchasedSelection: string) => void;
  mySelection?: string;
}

const InputPaymentMyTicket: React.FC<Props> = (props) => {
  const {
    onSelect,
    paymentMethod: { purchased_products, products },
    mySelection,
  } = props;
  const intl = useIntl();

  useEffect(() => {
    if (purchased_products.length !== 0) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }, [purchased_products, onSelect]);

  const handleSelect = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = e;
      onSelect(value);
    },
    [onSelect],
  );

  const isDisplayRetailer = purchased_products.length === 0;

  return (
    <li className={css.InputPaymentMyTicket}>
      {purchased_products.map((p) => (
        <div className={css.availableTicketWrap}>
          <CheckInput
            key={p.public_id}
            labelPosition="SpaceBetween"
            type={InputType.Radio}
            // ここでticket_bookのidを指定している
            value={p.public_id}
            checked={mySelection === p.public_id.toString()}
            // @ts-expect-error strictFunctionTypes
            onChange={handleSelect}
            name="payment-ticket"
          >
            <span>
              {p.name}
              &nbsp;&nbsp;&nbsp;
              {p.consumption}
              {intl.formatMessage({ id: 'books.paymentMethod.consumption' })}
              {p.ticket_books.map((t) => (
                <React.Fragment key={t.public_id}>
                  <span className={css.InputPaymentMyTicket__Description}>
                    {intl.formatMessage({
                      id: 'books.paymentMethod.expirationDate',
                    })}
                    〜
                    <FormattedDate
                      value={new Date(t.expires_at * 1000)}
                      year="numeric"
                      month="short"
                      day="numeric"
                    />
                    &nbsp;&nbsp;&nbsp;
                    {intl.formatMessage({ id: 'books.paymentMethod.rest' })}
                    {t.remain_count}
                  </span>
                </React.Fragment>
              ))}
            </span>
          </CheckInput>
        </div>
      ))}
      {isDisplayRetailer && (
        <div className={css.InputPaymentMyTicket__Available}>
          <div className={css.youCanGetFromHere}>
            {intl.formatMessage({
              id: 'books.forms.youGetSubscriptionAndTicket',
            })}
            <br />
            {intl.formatMessage({
              id: 'books.forms.pleaseRefreshBrowser',
            })}
          </div>
          <div className={css.productListWrap}>
            <BookingPurchaseProductList products={products} />
          </div>
        </div>
      )}
    </li>
  );
};

export default InputPaymentMyTicket;
